export const experienceData = [
    {
        id: 1,
        company: 'TechnaMax',
        jobtitle: 'Quality Assurance Developer',
        startYear: '2024',
        endYear: '2025'
    },
    {
        id: 2,
        company: 'NaqviX Solutions',
        jobtitle: 'FullStack Developer',
        startYear: '2025',
        endYear: '2026'
    },
    {
        id: 3,
        company: 'Dysol Technologies',
        jobtitle: 'Reserch and Development Lead',
        startYear: '2026',
        endYear: 'Present'
    },
]